// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrapper[data-v-5c1b73b8]{width:100%;height:100%;display:flex;justify-content:center;align-items:center;flex-direction:column;text-align:center}.wrapper .error[data-v-5c1b73b8]{font-size:40px}.wrapper .message[data-v-5c1b73b8]{margin-bottom:40px;font-size:16px}.wrapper .message-btn[data-v-5c1b73b8]{text-decoration:none}", ""]);
// Exports
module.exports = exports;
